import React, { useEffect, useState } from "react";
import { GetGradeColour } from "../helpers/gradeHelper";
import { IGradeRangeProps } from "../types/IGradeRangeProps";
import styles from "./GradeRange.module.css";

export const GradeRange = (props: IGradeRangeProps) => {
    const [fillColor, setFillColor] = useState<string>("");
    const [scoreColor, setScoreColor] = useState<string>("");
    const [scoreText, setScoreText] = useState<string>("");

    useEffect(() => {
        if (props.grade) {
            setScoreText(props.grade.toString());
            setBackgroundColor(props.grade);
        } else if (props.gradeMin && props.gradeMax) {
            if (props.gradeMin > props.gradeMax) {
                throw new Error("Grade min cannot be greater than grade max");
            }

            const midPoint = (props.gradeMax + props.gradeMin) / 2;

            setBackgroundColor(midPoint);
            setScoreText(`${props.gradeMin}-${props.gradeMax}`);
        } else {
            setScoreText("");
            setBackgroundColor(props.grade);
        }
    }, [props]);

    const setBackgroundColor = (idwalGrade?: number) => {
        const [scoreColor, fillColor] = GetGradeColour(idwalGrade);
        setScoreColor(scoreColor);
        setFillColor(fillColor);
    };

    return (
        <div className={styles.gradeWrapper}>
            <svg
                data-testid="gradeLozengeFillLeft"
                width="13"
                height="30"
                viewBox="0 0 13 30"
                fill={fillColor}
                xmlns="http://www.w3.org/2000/svg"
            >
                <path d="M5.74861 4.95911e-05L13 0V30L12.3177 30.0001C9.15646 30.0001 7.63675 27.1908 5.09714 20.1478C2.55753 13.1048 0 8.76208 0 5.67345C0.0098609 4.17177 0.618683 2.73437 1.69463 1.6725C2.77057 0.610638 4.22703 0.00978147 5.74861 4.95911e-05Z" />
            </svg>
            <span
                style={{
                    backgroundColor: fillColor,
                    color: scoreColor,
                    width: scoreText ? "auto" : "20px"
                }}
                data-testid="scoreText"
                className={styles.gradeLozenge}
            >
                {scoreText}
            </span>
            <svg
                data-testid="gradeLozengeFillRight"
                width="6"
                height="30"
                viewBox="0 0 6 30"
                fill={fillColor}
                xmlns="http://www.w3.org/2000/svg"
            >
                <path d="M4.31118 28.3337C3.23408 29.3966 1.77455 29.9957 0.251381 30L0 30V0L0.251381 3.8147e-06C1.77465 0.00435729 3.23427 0.603486 4.31139 1.66651C5.38851 2.72954 5.99559 4.17006 6 5.6734V24.3272C5.99543 25.8304 5.38828 27.2708 4.31118 28.3337Z" />
            </svg>
        </div>
    );
};
